import { Card } from '@app/components'
import { CardProps } from '@app/types'
import styled from 'styled-components'

export const StyledWalletCard = styled((props: CardProps) => <Card {...props} />)`
  display: flex;
  width: 100%;
  height: 256px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
